export enum Roles {
    Employee = 'employee',
    GlobalReports = 'globalReports',
    Management = 'management',
    MutationPreviousPeriod = 'mutationPreviousPeriod',
    MutationPrevPreviousPeriod = 'mutationPrevPreviousPeriod',
    PdfUnderlay = 'pdfUnderlay',
    SeireManagement = 'seireManagement',
    Tester = 'tester',
}
